/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompaniesCorporationTypesRetrieve200,
  CompaniesCorporationTypesRetrieveParams,
  CompaniesIntentOptionsRetrieve200,
  CompaniesLeadSourceOptionsRetrieve200,
  CompaniesMyCompaniesRetrieveParams,
  CompaniesRegisterCreate201,
  Company,
  CompanyRegisterRequest,
  CompanyUpdateRequest,
  CompanyVerificationStatus,
  PaginatedCompany
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Return a curated list of common corporation/legal-entity types for the supplied ISO 3166-1 alpha-2 country code (e.g. `DE` → GmbH/AG/UG/...). An `Other` entry is always appended so the form can fall back to free text. If `country` is omitted, a generic default list is returned. This endpoint is read-only and does not require authentication.
 * @summary Suggested corporation types for a country
 */
export const companiesCorporationTypesRetrieve = (
    params?: CompaniesCorporationTypesRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompaniesCorporationTypesRetrieve200>(
      {url: `/api/v1/companies/corporationTypes/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompaniesCorporationTypesRetrieveQueryKey = (params?: CompaniesCorporationTypesRetrieveParams,) => {
    return [`/api/v1/companies/corporationTypes/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompaniesCorporationTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>, TError = unknown>(params?: CompaniesCorporationTypesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesCorporationTypesRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>> = ({ signal }) => companiesCorporationTypesRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesCorporationTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>>
export type CompaniesCorporationTypesRetrieveQueryError = unknown

/**
 * @summary Suggested corporation types for a country
 */
export const useCompaniesCorporationTypesRetrieve = <TData = Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>, TError = unknown>(
 params?: CompaniesCorporationTypesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesCorporationTypesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesCorporationTypesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Option lists (value + label) for the corridor/intent fields on the registration and profile forms (WP1.5). `corridorSides` and `corridors` come from the configured trade corridors, so a new corridor appears here without a frontend change. Public.
 * @summary Corridor and intent options
 */
export const companiesIntentOptionsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompaniesIntentOptionsRetrieve200>(
      {url: `/api/v1/companies/intentOptions/`, method: 'GET', signal
    },
      );
    }
  

export const getCompaniesIntentOptionsRetrieveQueryKey = () => {
    return [`/api/v1/companies/intentOptions/`] as const;
    }

    
export const getCompaniesIntentOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesIntentOptionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>> = ({ signal }) => companiesIntentOptionsRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesIntentOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>>
export type CompaniesIntentOptionsRetrieveQueryError = unknown

/**
 * @summary Corridor and intent options
 */
export const useCompaniesIntentOptionsRetrieve = <TData = Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesIntentOptionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesIntentOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Options for the registration form's "Where did you hear about us?" block (WP1.9): the source types and the active named sources (managed by super moderators). Empty `sources` is normal until moderators add some — the form then falls back to free text. Public.
 * @summary Lead source options
 */
export const companiesLeadSourceOptionsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompaniesLeadSourceOptionsRetrieve200>(
      {url: `/api/v1/companies/leadSourceOptions/`, method: 'GET', signal
    },
      );
    }
  

export const getCompaniesLeadSourceOptionsRetrieveQueryKey = () => {
    return [`/api/v1/companies/leadSourceOptions/`] as const;
    }

    
export const getCompaniesLeadSourceOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesLeadSourceOptionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>> = ({ signal }) => companiesLeadSourceOptionsRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesLeadSourceOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>>
export type CompaniesLeadSourceOptionsRetrieveQueryError = unknown

/**
 * @summary Lead source options
 */
export const useCompaniesLeadSourceOptionsRetrieve = <TData = Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesLeadSourceOptionsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesLeadSourceOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get all companies associated with the current user with their roles. Paginated.
 * @summary Get user companies
 */
export const companiesMyCompaniesRetrieve = (
    params?: CompaniesMyCompaniesRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedCompany>(
      {url: `/api/v1/companies/myCompanies/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompaniesMyCompaniesRetrieveQueryKey = (params?: CompaniesMyCompaniesRetrieveParams,) => {
    return [`/api/v1/companies/myCompanies/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompaniesMyCompaniesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>, TError = unknown>(params?: CompaniesMyCompaniesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesMyCompaniesRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>> = ({ signal }) => companiesMyCompaniesRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesMyCompaniesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>>
export type CompaniesMyCompaniesRetrieveQueryError = unknown

/**
 * @summary Get user companies
 */
export const useCompaniesMyCompaniesRetrieve = <TData = Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>, TError = unknown>(
 params?: CompaniesMyCompaniesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesMyCompaniesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesMyCompaniesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 
        Register a new company. This is a public endpoint.
        Company will be created as pending and needs admin approval.
        
 * @summary Register company
 */
export const companiesRegisterCreate = (
    companyRegisterRequest: CompanyRegisterRequest,
 ) => {
      
      
      return customInstance<CompaniesRegisterCreate201>(
      {url: `/api/v1/companies/register/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyRegisterRequest
    },
      );
    }
  


export const getCompaniesRegisterCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesRegisterCreate>>, TError,{data: CompanyRegisterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesRegisterCreate>>, TError,{data: CompanyRegisterRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesRegisterCreate>>, {data: CompanyRegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  companiesRegisterCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesRegisterCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesRegisterCreate>>>
    export type CompaniesRegisterCreateMutationBody = CompanyRegisterRequest
    export type CompaniesRegisterCreateMutationError = void

    /**
 * @summary Register company
 */
export const useCompaniesRegisterCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesRegisterCreate>>, TError,{data: CompanyRegisterRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesRegisterCreate>>,
        TError,
        {data: CompanyRegisterRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesRegisterCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 
        Update company profile. Only the owner of the company can update it.
        Company email cannot be changed.
        For avatar, first upload the file using /api/v1/common/upload/ and then use the returned URL here.
        
 * @summary Update company profile
 */
export const companiesUpdateProfileUpdate = (
    companyUpdateRequest: CompanyUpdateRequest,
 ) => {
      
      
      return customInstance<Company>(
      {url: `/api/v1/companies/updateProfile/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companyUpdateRequest
    },
      );
    }
  


export const getCompaniesUpdateProfileUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>, TError,{data: CompanyUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>, TError,{data: CompanyUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>, {data: CompanyUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  companiesUpdateProfileUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesUpdateProfileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>>
    export type CompaniesUpdateProfileUpdateMutationBody = CompanyUpdateRequest
    export type CompaniesUpdateProfileUpdateMutationError = void

    /**
 * @summary Update company profile
 */
export const useCompaniesUpdateProfileUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>, TError,{data: CompanyUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesUpdateProfileUpdate>>,
        TError,
        {data: CompanyUpdateRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesUpdateProfileUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * High level only: not_started | in_progress | verified | action_needed, and the company's public badge. `verified` means a moderator awarded a badge backed by a registry match and clear screening. Never screening hits, lists or counts.
 * @summary My company's verification status
 */
export const verificationMyStatusRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyVerificationStatus>(
      {url: `/api/v1/verification/myStatus/`, method: 'GET', signal
    },
      );
    }
  

export const getVerificationMyStatusRetrieveQueryKey = () => {
    return [`/api/v1/verification/myStatus/`] as const;
    }

    
export const getVerificationMyStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof verificationMyStatusRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationMyStatusRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerificationMyStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verificationMyStatusRetrieve>>> = ({ signal }) => verificationMyStatusRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verificationMyStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type VerificationMyStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof verificationMyStatusRetrieve>>>
export type VerificationMyStatusRetrieveQueryError = void

/**
 * @summary My company's verification status
 */
export const useVerificationMyStatusRetrieve = <TData = Awaited<ReturnType<typeof verificationMyStatusRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verificationMyStatusRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getVerificationMyStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



